import { defaultHttpClient } from '../../httpClient';
import type { GetMarketAiStudioProductInfoResponse } from './types';

export const getMarketAiStudioProductInfo = (marketId: number) => {
  return defaultHttpClient
    .request<GetMarketAiStudioProductInfoResponse>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/ai-studio-product-info/`,
    })
    .then(result => {
      return result.data;
    });
};
